import { IAppointmentsReport } from '../../../interface/IAppointmentsReport'
import { IAPIAppointmentsReport } from '../../interface/IAPIAppointmentsReport'

import { createGroupData } from './createGroupData'

export const formatForWeek = (
    apiData: IAPIAppointmentsReport[]
): IAppointmentsReport[] => {
    const weekStartDay = 0

    const daysOfWeekArray = Array.from(
        { length: 7 },
        (v, i) => weekStartDay + i
    )

    return daysOfWeekArray.map(
        (dayNumber): IAppointmentsReport => createGroupData(apiData, dayNumber, 'day')
    )
}
